import { handleError } from './handler-error';

export const createThunk = thunk => (dispatch, getState, args) => thunk(handleError(dispatch), getState, args);



// WEBPACK FOOTER //
// ./app/services/create-thunk.js